import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.cssmodule.css';

function Card({ id, className, children }) {
  return (
    <div id={id} className={`${styles.container} ${className}`}>
      {children}
    </div>
  );
}
Card.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};
Card.defaultProps = {
  id: null,
  className: '',
};

function CardHeader({ children }) {
  return (
    <header className={styles.cardHeader}>
      {children}
    </header>
  );
}
CardHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

function CardTitle({ children }) {
  return (
    <h3 className={styles.cardTitle}>
      {children}
    </h3>
  );
}

CardTitle.propTypes = {
  children: PropTypes.node.isRequired,
};

function CardDivider() {
  return (
    <div className={styles.divider} />
  );
}

function CardBody({ children }) {
  return (
    <div>
      {children}
    </div>
  );
}
CardBody.propTypes = {
  children: PropTypes.node.isRequired,
};

export {
  Card,
  CardHeader,
  CardTitle,
  CardDivider,
  CardBody,
};



// WEBPACK FOOTER //
// ./components/card/Card2.jsx